import { io } from "socket.io-client";
import environment from "../../environment";

// Replace this URL with your backend server's URL
const SOCKET_SERVER_URL = environment.api || process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:6089';

const socket = io(SOCKET_SERVER_URL, {
  transports: ["websocket", "polling"], // polling en secours si ws coupé/relancé (restart backend)
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});

export default socket;
